import React from 'react';
import { getMaturity } from '../../utils/scoring';

/**
 * Coloured dot + label for a maturity score.
 * Props: score (number|null), size ('sm'|'md')
 */
export default function MaturityLabel({ score, size = 'md' }) {
  const maturity = getMaturity(score);
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';
  const dotSize = size === 'sm' ? 'w-2 h-2' : 'w-2.5 h-2.5';

  return (
    <span className={`inline-flex items-center gap-1.5 ${textSize} font-medium`} style={{ color: maturity.color }}>
      <span
        className={`inline-block rounded-full ${dotSize} shrink-0`}
        style={{ backgroundColor: maturity.color }}
      />
      {maturity.label}
    </span>
  );
}
